import { setElementVisible } from '../../../../shared/DOM/setElementVisible.js';
import { getLinkFooter } from '../getLinkFooter.js';
import { getInputDomain } from '../getLoginView.js';

/**
 * Partial view del login: Acceso con certificado
 *
 * @returns Cert Access View json
 */
export function getCertAccessView() {
  const inputDomain = getInputDomain();
  if (document.querySelector('html')?.hasAttribute('domain-concentration')) {
    inputDomain.disabled = true;
  }

  const formProperties = [
    {
      name: 'certAlert',
      type: 'alert',
      metadata: {
        closable: false,
        style: 'danger',
      },
      cols: 8,
    },
    inputDomain,
    {
      name: 'btnCertSubmit',
      type: 'button',
      title: edicom.locale.translate('global.acceder'),
      metadata: {
        icon: 'right-to-bracket',
        style: 'primary fill',
      },
      cols: 8,
    },
  ];

  return {
    properties: [
      {
        type: 'object',
        name: 'CertAccess.html',
        cols: 4,
        properties: formProperties,
      },
      {
        type: 'object',
        name: 'info',
        cols: 4,
        properties: [
          {
            name: 'infoAlert',
            type: 'alert',
            metadata: {
              closable: false,
              style: 'flat',
              content: getInfoAlertContent(),
            },
            cols: 8,
          },
        ],
      },
    ],
  };
}

function getInfoAlertContent() {
  return `<div style="white-space:normal"><p><ewc-icon name="certificate" style="display: inline-flex"></ewc-icon>
    <strong style="text-transform: uppercase"><span>${edicom.locale.translate('login.certificate')}</span></strong></p>
  ${edicom.locale.translate('global.introCert1')}
  <br/><br/>
  ${getLinkFooter('faqs', 'global.introCert2', 'https://help.edicomgroup.com/faqs/index.htm')}`;
}

function getCertAccessViewAlert() {
  return document.querySelector('ewc-alert[view-name="certAlert"]');
}

export function getCertAccessBtnSubmit() {
  return document.querySelector('ewc-button[view-name="btnCertSubmit"]');
}

export function hideCertAccessError() {
  const eAlert = getCertAccessViewAlert();
  setElementVisible(eAlert, false);
}

export function showCertAccessError(message, params) {
  const eAlert = getCertAccessViewAlert();
  setElementVisible(eAlert, true);
  eAlert.innerHTML = edicom.locale.translate(message, params);
}
